"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  addChildren: () => addChildren,
  applyMask: () => applyMask,
  createShiftMask: () => createShiftMask,
  createStrengthenMask: () => createStrengthenMask,
  createTheme: () => createTheme,
  createWeakenMask: () => createWeakenMask
});
module.exports = __toCommonJS(src_exports);
const THEME_INFO = /* @__PURE__ */ new WeakMap();
function createTheme(palette, definition, options) {
  const theme = {
    ...Object.fromEntries(
      Object.entries(definition).map(([key, offset]) => {
        return [key, getValue(palette, offset)];
      })
    ),
    ...options == null ? void 0 : options.nonInheritedValues
  };
  THEME_INFO.set(theme, { palette, definition, cache: /* @__PURE__ */ new Map() });
  return theme;
}
const getValue = (palette, value) => {
  if (typeof value === "string")
    return value;
  const max = palette.length - 1;
  const isPositive = value === 0 ? !isMinusZero(value) : value >= 0;
  const next = isPositive ? value : max + value;
  const index = Math.min(Math.max(0, next), max);
  return palette[index];
};
function addChildren(themes, getChildren) {
  const out = { ...themes };
  for (const key in themes) {
    const subThemes = getChildren(key, themes[key]);
    for (const sKey in subThemes) {
      out[`${key}_${sKey}`] = subThemes[sKey];
    }
  }
  return out;
}
const createShiftMask = ({ inverse } = {}) => {
  return (template, { skip, max: maxIn, palette, min = 0, strength = 1 }) => {
    const values = Object.entries(template);
    const max = maxIn ?? (palette ? Object.values(palette).length - 1 : Infinity);
    const out = {};
    for (const [key, value] of values) {
      if (typeof value === "string")
        continue;
      if (skip && key in skip) {
        continue;
      }
      const isPositive = value === 0 ? !isMinusZero(value) : value >= 0;
      const direction = isPositive ? 1 : -1;
      const invert = inverse ? -1 : 1;
      const next = value + strength * direction * invert;
      const clamped = isPositive ? Math.max(min, Math.min(max, next)) : Math.min(-min, Math.max(-max, next));
      out[key] = clamped;
    }
    return out;
  };
};
const createWeakenMask = () => createShiftMask();
const createStrengthenMask = () => createShiftMask({ inverse: true });
function isMinusZero(value) {
  return 1 / value === -Infinity;
}
const MaskKeyCache = /* @__PURE__ */ new WeakMap();
function applyMask(theme, mask, options = {}) {
  const info = THEME_INFO.get(theme);
  if (!info) {
    throw new Error(
      process.env.NODE_ENV !== "production" ? `No info found for theme, you must pass the theme created by createThemeFromPalette directly to extendTheme` : `\u274C Err2`
    );
  }
  const maskKey = MaskKeyCache.get(mask) ?? `${Math.random()}`;
  MaskKeyCache.set(mask, maskKey);
  const key = `${maskKey}${JSON.stringify(options)}`;
  if (info.cache.has(key)) {
    return info.cache.get(key);
  }
  const template = mask(info.definition, {
    palette: info.palette,
    ...options
  });
  const next = createTheme(info.palette, template);
  info.cache.set(key, next);
  return next;
}
if (process.env.NODE_ENV === "development") {
  const palette = ["0", "1", "2", "3", "-3", "-2", "-1", "-0"];
  const template = { bg: 1, fg: -1 };
  const stongerMask = createStrengthenMask();
  const weakerMask = createWeakenMask();
  const theme = createTheme(palette, template);
  if (theme.bg !== "1")
    throw `\u274C`;
  if (theme.fg !== "-1")
    throw `\u274C`;
  const str = applyMask(theme, stongerMask);
  if (str.bg !== "0")
    throw `\u274C`;
  if (str.fg !== "-0")
    throw `\u274C`;
  const weak = applyMask(theme, weakerMask);
  if (weak.bg !== "2")
    throw `\u274C`;
  if (weak.fg !== "-2")
    throw `\u274C`;
  const weak2 = applyMask(theme, weakerMask, { strength: 2 });
  if (weak2.bg !== "3")
    throw `\u274C`;
  if (weak2.fg !== "-3")
    throw `\u274C`;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  addChildren,
  applyMask,
  createShiftMask,
  createStrengthenMask,
  createTheme,
  createWeakenMask
});
//# sourceMappingURL=index.js.map
